import React, { Component } from 'react';
import axios from '../../../axios-ns';

import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';

import Aux from '../../../hoc/Aux';
import * as messages from '../../../messages';
import Spinner from '../../../components/UI/Spinner/Spinner';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarHalf';

class Metronome extends Component {
    state = {
        time: 0,
        tempo: 0,
        interval: null
    }

    componentDidMount() {
        this.setState({...this.state, time: this.props.time, tempo: this.props.tempo});
    }

    start = () => {
        this.setState({...this.state, interval: setInterval(() => document.getElementById('my_audio').play(), 60 / this.state.tempo * 1000)});
        setTimeout(() => this.stop(), this.state.time * 1000);

    }

    stop = () => {
        clearInterval(this.state.interval);
        this.setState({...this.state, interval: null});
    }

    handleChange = (event, key) => {
        let val = event.target.value;
        if(val > 480) val = 480;
        if(val < 0) val = 0;
        this.setState({...this.state, [key]: val });
    }


    render() {

        let button = !this.state.interval ? <Button color="primary" variant="contained" onClick={() => this.start()}>Start</Button> : <Button onClick={() => this.stop()} color="primary" variant="contained" >Stop</Button>

        return <Card>
            <CardHeader title="Metronom" avatar={
                            <Avatar aria-label="Recipe" style={{ backgroundColor: 'gold' }}>
                                ME
                            </Avatar>
                        }/>
            <CardContent>
            <form>
                Uderzenia na minutę: <TextField type="number" value={this.state.tempo} onChange={(event) => this.handleChange(event, 'tempo')}/><br/><br/>
                Długość ćwiczenia: <TextField type="number" value={this.state.time} onChange={(event) => this.handleChange(event, 'time')}/> sek<br/><br/>
            </form>
            <p style={{textAlign: 'center'}}>
            {button}</p>

            <audio display="none" style={{'marginLeft': '-1000px'}} controls preload="none" id="my_audio">
                <source src="http://nauka-spiewu.pl/assets/audio/tick/tick.wav" type="audio/wav"/>
            </audio>

            </CardContent>
        </Card>
    }
}

export default Metronome; 